import { useState, useEffect } from "react"
import { useLocation, Link } from "react-router-dom"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Collapse from "@mui/material/Collapse"
import InboxIcon from "@mui/icons-material/MoveToInbox"
import ExpandLess from "@mui/icons-material/ExpandLess"
import ExpandMore from "@mui/icons-material/ExpandMore"
import StarBorder from "@mui/icons-material/StarBorder"
import { useTranslate } from "ra-core"

export default function ReferenceBooksItem(): JSX.Element {
    const location = useLocation()
    const [open, setOpen] = useState(true)
    const translate = useTranslate()

    const handleClick = () => {
        setOpen(!open)
    }

    useEffect(() => {
        if (location.pathname.startsWith("/references/")) {
            setOpen(true)
        }
    }, [location.pathname])

    return (
        <>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon style={{minWidth: '36px'}}>
                    <InboxIcon />
                </ListItemIcon>
                <ListItemText primary={translate("menu.reference_books")} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <>
                    <ListItemButton sx={{ pl: 4 }} component={Link} to="/references/drivers" className="custom-submenu-lev-2">
                        <ListItemIcon style={{minWidth: '36px'}}>
                            <StarBorder />
                        </ListItemIcon>
                        <ListItemText primary={translate("menu.drivers_params")} />
                    </ListItemButton>
                </>
            </Collapse>
        </>
    )
}
